import {
    getRoles,
    getAllRoles,
    deleteRole,
    createRole,
    updateRole
} from '../../../services/RolesService';
import {
    CONFIRMED_GET_ROLES
} from './RoleTypes';

export function getRolesAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_ROLES_LOADING', payload: true });
        getRoles(currentPage, pageSize, searchTerm, filterQuery).then((response) => {
            dispatch(confirmedGetRolessAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'SET_ROLES_LOADING', payload: false });
        });
    };
}

export function getAllRolesAction(currentPage, pageSize) {
    return (dispatch, getState) => {
        getAllRoles().then((response) => {
            dispatch(confirmedGetRolessAction(response.data.data));
        });
    };
}

export function confirmedGetRolessAction(users) {
    return {
        type: CONFIRMED_GET_ROLES,
        payload: users,
    };
}

export function deleteRoleAction(roleId, history) {
    return (dispatch, getState) => {
        return deleteRole(roleId).then((response) => {
            return response;
        });
    };
}

export function createRoleAction(roleData) {
    return () => {
        return createRole(roleData).then((response) => {
            return response;
        });
    };
}

export function updateRoleAction(roleId, roleData) {
    return () => {
        return updateRole(roleId, roleData).then((response) => {
            return response;
        });
    };
}

